// The global function that sets title so it's no longer a prop dependency.
const setTitle = (title: string) => {
	window.document.title = title;
};

export default setTitle;
